<form [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="card box">
    <div class="grid p-fluid p-3">
      <div class="col-12">
        <img style="max-width: 100%;" src="assets/images/png/logo.png">
      </div>
      <div class="col-12 lg:col-12 md:col-12">
        <div class="input-wrapper">
          <input #input formControlName="usuario" placeholder="Usuário" type="text" autocomplete="off" pInputText>
        </div>
      </div>
      <div class="col-12 lg:col-12 md:col-12">
        <div class="input-wrapper">
          <input formControlName="senha" placeholder="Senha" type="password" autocomplete="off" pInputText>
        </div>
      </div>
      <div class="col-12 lg:col-12 md:col-12">
        <button [disabled]="loading" style="width: 100%;" [icon]="loading ? 'pi pi-spin pi-spinner' : 'pi pi-sign-in'"
          type="submit" pButton [label]="loading ? '' : 'Entrar'"></button>
      </div>
    </div>
  </div>
</form>